import { Component,NgModule, OnInit } from '@angular/core';

@Component({
  selector: 'ex-user-info-dialog',
  templateUrl: './user-info-dialog.component.html',
  styleUrls: ['./user-info-dialog.component.css']
})
export class UserInfoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

@NgModule({
    imports:[],
    declarations:[UserInfoDialogComponent],
    exports:[UserInfoDialogComponent],
    providers:[]
})
export class UserInfoDialogModule{
}


// WEBPACK FOOTER //
// ./src/app/component/user-info-dialog/user-info-dialog.component.ts